import { v4 } from "uuid";

export const getEmptyTextLine = (contentId: string) => {
	return {
		id: v4(),
		contentId,
		textContent: "",
		previousText: "",
		revision: 0,
		sequence: 1
	};
};
